// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CallSpectatorView_wrapper__3jDZm"};